import { env } from '../../app.env';

export class RequestTokenParams {
    protected client_id = env.oauth_client.id;
    protected client_secret = env.oauth_client.secret;
    protected scope = '*';

    grant_type: string;
    username: string;
    password: string;
    provider: string;
    access_token: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/shared/models/request-token-params.model.ts